import * as Sentry from '@sentry/vue'
import type { Plugin } from 'vue'

const sentryPlugin: Plugin = {
	install: (app) => {
		if (
			import.meta.env.PROD
				&& import.meta.env.VITE_SENTRY_DSN
				&& import.meta.env.VITE_SENTRY_DSN !== 'null'
		) {
			Sentry.init({
				app,
				dsn: import.meta.env.VITE_SENTRY_DSN,
				tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
				integrations: [
					Sentry.browserTracingIntegration(),
				],
			})
		}
	},
}

export default sentryPlugin
